export enum ERoleType {
  SUPER_ADMIN = "SuperAdmin",
  ADMIN = "Admin",
  SUPERVISOR = "Supervisor",
  OPERATOR = "Operator",
  PLANNER = "Planner",
  VIEW = "View",
}
